import React from 'react';
import { Card, CardContent } from '../ui/card.jsx';
import { TicketIcon, AlertCircle, CheckCircle, Clock } from 'lucide-react';

export default function InternalTicketStats({ stats, isLoading }) {
  const items = [
    {
      title: 'Total de Chamados',
      value: stats?.total || 0,
      icon: TicketIcon,
      color: 'text-blue-500',
      bgColor: 'bg-blue-100',
    },
    {
      title: 'Em Aberto',
      value: stats?.open || 0,
      icon: Clock,
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-100',
    },
    {
      title: 'SLA Violado',
      value: stats?.overdue || 0,
      icon: AlertCircle,
      color: 'text-red-500',
      bgColor: 'bg-red-100',
    },
    {
      title: 'Resolvidos',
      value: stats?.resolved || 0,
      icon: CheckCircle,
      color: 'text-green-500',
      bgColor: 'bg-green-100',
    },
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item, i) => (
          <Card key={i} className="overflow-hidden">
            <CardContent className="p-0">
              <div className="flex h-24 items-center justify-between p-6 animate-pulse">
                <div className="space-y-2">
                  <div className="h-4 w-20 bg-gray-200 rounded"></div>
                  <div className="h-6 w-10 bg-gray-300 rounded"></div>
                </div>
                <div className="h-12 w-12 rounded-full bg-gray-200"></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item, i) => (
        <Card key={i} className="overflow-hidden transition-all hover:shadow-md">
          <CardContent className="p-0">
            <div className="flex h-24 items-center justify-between p-6">
              <div>
                <p className="text-sm font-medium text-muted-foreground">{item.title}</p>
                <p className="text-2xl font-bold">{item.value}</p>
              </div>
              <div className={`rounded-full p-2 ${item.bgColor}`}>
                <item.icon className={`h-6 w-6 ${item.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}